module.exports = __webpack_public_path__ + "static/media/Trucker-hats-banner.fd194aab.jpg";